/**
 * Device fingerprint for session binding (issue #196).
 *
 * Computed once per page load via @fingerprintjs/fingerprintjs's free,
 * open-source core library (canvas/WebGL/font-list derived, not the paid
 * Pro API) and cached — client.js's request interceptor attaches it as the
 * X-Device-Fingerprint header on every request, and the backend compares it
 * against the value captured at login. It's a genuine device-level signal,
 * unlike the User-Agent string, which a client can just type a different
 * value into.
 *
 * Fails soft, always: if the library is blocked (ad-blocker, privacy
 * extension, an old cached bundle without it) or throws for any reason,
 * getDeviceFingerprint() resolves to null and the request just goes out
 * without the header. The backend already treats a missing fingerprint as
 * "skip this check", never as suspicious — this is additive hardening on
 * top of the other session-binding signals, never a login requirement.
 */
let cached = null;
let inFlight = null;

export async function getDeviceFingerprint() {
    if (cached) return cached;
    if (!inFlight) {
        inFlight = (async () => {
            try {
                const FingerprintJS = await import('@fingerprintjs/fingerprintjs');
                const fp = await FingerprintJS.load();
                const result = await fp.get();
                cached = result.visitorId;
                return cached;
            } catch (err) {
                return null;
            }
        })();
    }
    return inFlight;
}
